import React from "react";
import { motion } from "framer-motion";
import { Star, Quotes } from "@phosphor-icons/react";
import { useLang } from "../../context/LanguageContext";
import { Reveal, Kicker } from "./Reveal";

const Stars = ({ n = 5 }) => (
  <div className="flex gap-1" aria-label={`${n} stars`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={18} weight="fill" className={i < n ? "text-taxi" : "text-white/15"} />
    ))}
  </div>
);

export const Testimonials = ({ content }) => {
  const { t, lang, pick } = useLang();
  const items = content?.testimonials || [];
  if (!items.length) return null;

  return (
    <section id="reviews" className="relative bg-taxi py-24 md:py-36 border-t border-black/10" data-testid="testimonials-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <Reveal><Kicker>{t("reviews_kicker")}</Kicker></Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display text-black text-5xl md:text-8xl uppercase leading-[0.9]">{t("reviews_title")}</h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <div className="flex items-center gap-3">
              <Stars n={5} />
              <span className="text-black/70 text-sm font-semibold">5.0 · {items.length} {lang === "en" ? "reviews" : "reseñas"}</span>
            </div>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {items.map((r, i) => (
            <Reveal key={i} delay={(i % 4) * 0.08}>
              <motion.div whileHover={{ y: -8 }} transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                className="group relative border border-white/10 bg-surface p-7 h-full flex flex-col hover:border-taxi/40"
                data-testid={`testimonial-${i}`}>
                <Quotes size={34} weight="fill" className="text-taxi/30 mb-4 group-hover:text-taxi/60 transition-colors" />
                <p className="text-white/75 text-sm md:text-base leading-relaxed flex-1">"{pick(r, "text")}"</p>
                <div className="mt-6 pt-5 border-t border-white/10">
                  <Stars n={r.rating || 5} />
                  <div className="font-display text-white text-xl uppercase mt-3 leading-none">{r.name}</div>
                  {r.location && <div className="text-white/40 text-xs uppercase tracking-widest mt-1">{r.location}</div>}
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
